
const APP_BASE_URL = "/demetra/";

export const routesPaths = {
    //CUSTOMER
    "customer" : APP_BASE_URL+"customer",
    "customerUsers" : APP_BASE_URL+"customer/users",
    
    //WALLET
    "wallet" : APP_BASE_URL+"wallet",
    "walletStatistics" : APP_BASE_URL + "wallet/statistics",
    "walletUsers": APP_BASE_URL+"wallet/users",
    "walletVouchers": APP_BASE_URL+"wallet/vouchers",
    "walletVouchersCampaign": APP_BASE_URL+"wallet/vouchers/campaign",
        
    //PaymentGateway
    "paymentGateway" : APP_BASE_URL + "paymentGateway",
    "paymentGatewayStatistics" : APP_BASE_URL + "payment-gateway/statistics",
    "paymentGatewayTransactions" : APP_BASE_URL + "payment-gateway/transactions",
    "uploadPayment" : APP_BASE_URL + "payment-gateway/payment",
    "uploadCredit" : APP_BASE_URL + "payment-gateway/Credit",
    "reconciliationSearch" : APP_BASE_URL +"reconciliation/search",
    "reconciliationFile" : APP_BASE_URL +"reconciliation/file",
    "reconciliationFailDay" : APP_BASE_URL +"reconciliation/fail/day",
    "scheduledPayments" : APP_BASE_URL+"payment-gateway/scheduled",
    
    //PaymentHub
    "paymentHub" : APP_BASE_URL + "payment-hub",
    "paymentHubStatistics" : APP_BASE_URL + "payment-hub",
    "bulkSdd" : APP_BASE_URL+"payment-hub/sdd",
    "bulkSdd_sub" : APP_BASE_URL+"payment-hub/sdd/bulk",
    "debitSdd" : APP_BASE_URL+"payment-hub/sdd/debit",
    "bulkSct" : APP_BASE_URL+"payment-hub/sct",
    "bulkSct_sub" : APP_BASE_URL+"payment-hub/sct/bulk",
    "sct" : APP_BASE_URL+"payment-hub/sct/credit",
    "downloadSdd" : APP_BASE_URL+"payment-hub/sdd/download",
    "downloadSct" : APP_BASE_URL+"payment-hub/sct/download",
    "mandate" : APP_BASE_URL+"payment-hub/mandate",
    "mandateList" : APP_BASE_URL+"payment-hub/mandate/list",
    "VoPcheck" : APP_BASE_URL+"payment-hub/vopcheck",
    "crossborder" : APP_BASE_URL+"payment-hub/sct/crossborder",

    //BILLING
    "billing" : APP_BASE_URL+"billing",
    "billingUsers" : APP_BASE_URL+"billing/users",
    "billingProduct" : APP_BASE_URL+"billing/products",

    //ADMINISTRATION
    "administration" : APP_BASE_URL+"admin",
    "config" : APP_BASE_URL+"admin/config",
    "usersDashboard" : APP_BASE_URL + "admin/users",
    "createUser" : APP_BASE_URL+"admin/users/add",

    //EMAILSENDER
    "emailDashboard" : APP_BASE_URL +"email/dashboard",
    "emailTemplate" : APP_BASE_URL +"email/template",

    //COMMISSIONS
    "commissionsProductsDashboard" : APP_BASE_URL + "commissions/products",
    "commissionsDashboard" : APP_BASE_URL + "commissions/dashboard"

};
